module.exports = __webpack_public_path__ + "static/img/4.9c9fc700.jpg";